import React, { useState } from "react";
import { ICellTextProps } from "ka-table/props";
import { useMutation } from "@tanstack/react-query";
import { Trash2 } from "lucide-react";
import { deleteAutomation } from "../../services/automation/automationEndpoints";
import notify from "../../utils/notify";
import { queryClient } from "../../hooks/QueryHooks";
import useWorkspaceStore from "../../store/workspace/workspaceStore";
import { Button, buttonVariants } from "../../components/ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../components/ui/alert-dialog";

const DeleteSignalCell: React.FC<ICellTextProps> = React.memo(
  ({ column, dispatch, rowKeyValue, ...props }) => {
    const workspace = useWorkspaceStore((state) => state.workspace);
    const [open, setOpen] = useState(false);

    const deleteAutomationMutation = useMutation({
      mutationFn: deleteAutomation,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["all_automations", workspace.id, "signal"],
        });
        notify({
          messageList: ["Signal deleted successfully"],
          type: "success",
        });
        setOpen(false);
      },
      onError: () => {
        notify({
          messageList: ["Failed to delete signal."],
          type: "failure",
        });
      },
    });

    const handleDelete = () => {
      deleteAutomationMutation.mutate({
        automation_id: props.rowData.id,
        workspace_id: workspace.id,
      });
    };

    return (
      <>
        <Button
          size="sm"
          variant="ghost"
          className="h-8 w-8 p-0"
          title="Delete"
          onClick={() => setOpen(true)}
        >
          <Trash2 className="h-4 w-4" />
        </Button>

        <AlertDialog open={open} onOpenChange={setOpen}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Delete Signal</AlertDialogTitle>
              <AlertDialogDescription>
                Are you sure you want to delete &quot;{props.rowData?.name || "this signal"}&quot;? This action cannot be undone.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction
                className={buttonVariants({ variant: "default" })}
                onClick={handleDelete}
              >
                Delete
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </>
    );
  },
);

export default DeleteSignalCell;
